import { FC } from 'react'
import CompletedPrintJobsPage from '../completed-print-jobs/completed-print-jobs-page'

interface ConsumptionPageProps {}

const ConsumptionPage: FC<ConsumptionPageProps> = () => {
    return <CompletedPrintJobsPage />
}

export default ConsumptionPage
